module.exports = __webpack_public_path__ + "static/image 3-1f0a8ff0ae20d676b64046af9dd46875.png";